
import {Vue, Watch, Component} from "vue-property-decorator";
import RelayCreate from "@/components/relays/RelayCreate.vue";
import UserListAvatar from "@/components/users/UserListAvatar.vue";
import {Getter} from "vuex-class";
import { ROWS_PER_PAGE } from "@/utils/constants";
import { CUSTOMER_SUCCESS_TYPE } from "@/utils/customerSuccess";

@Component({
    components: {
        RelayCreate,
        UserListAvatar,
    },
})

export default class Relay extends Vue {
    @Getter private isAdmin: boolean;
    @Getter private envCompanyId: number|null;
    @Getter private isCustomerSuccess: (companyId: number|null, csTypes: CUSTOMER_SUCCESS_TYPE[]) => boolean;

    get canCreateRelay(): boolean {
        return this.isAdmin || this.isCustomerSuccess(this.envCompanyId, [
            CUSTOMER_SUCCESS_TYPE.TRACABILITY, CUSTOMER_SUCCESS_TYPE.BUILDINGS_DEPLOYMENT,
        ]);
    }

    private loading: boolean = true;
    private relays: object[] = [];
    private relayType: string = null;
    private pagination: any = {};
    private ROWS_PER_PAGE = ROWS_PER_PAGE;
    private totalRelays: number = 0;
    private headers: object[] = [
        {value: "name", sortable: true},
        {value: "Referents", sortable: false},
        {value: "buildingId", sortable: false},
    ];
    private showCreate: boolean = false;

    @Watch("pagination", { deep: true })
    public handlerPagination(val, oldVal) {
        if (val.page === oldVal.page) {
            val.page = 1;
        }
        this.getRelays();
    }

    private mounted() {
        this.setPageType(this.$router.currentRoute.name);
    }

    private openRelayCreation(): void {
        this.showCreate = true;
    }

    private clickRow(item) {
        return this.$router.push({name: "relay", params: {id: item.id}});
    }

    private getRelays() {
      this.loading = true;
      return this.$store.dispatch("relays/getAll", {query: this.pagination})
            .then((res) => {
                this.relays = res.relays;
                this.totalRelays = res.count;
            })
            .catch((err) => {
                this.$store.commit("alerts/displayError", {
                    msg: err,
                });
            })
            .finally(() => {
              this.loading = false;
            });
    }

    private setPageType(routeName: string) {
        switch (routeName) {
            case "admin-relays-agency":
                this.relayType = this.pagination.type = "AGENCY";
                break;
            default:
                break;
        }
    }

  /**
   * Clicks on a row button, navigates to the building page with the given item's id as a parameter.
   *
   * @param {string} buildingId - The clicked row buildingId.
   * @returns {Promise} - A promise representing the navigation action.
   */
    private openBuilding(buildingId: string) {
        return this.$router.push({ name: "building", params: { id: buildingId } });
    }
}
